import { BaseFloorplanViewElement } from "./BaseFloorplanViewElement.js";
import {
  EVENT_ROOM_ATTRIBUTES_CHANGED,
  EVENT_CHANGED,
  EVENT_TRANSLATE_CLICKED,
} from "../core/events.js";
import { Dimensioning } from "../core/dimensioning.js";
import {
  Configuration,
  fontSize,
  currentFontSize,
} from "../core/configuration.js";
import { Vector2, EventDispatcher } from "three";
import { Text, Graphics, Sprite, Texture } from "pixi.js";
import { selectionColor } from "../core/constants.js";

export class RoomDimensions extends BaseFloorplanViewElement {
  constructor(floorplan, options, room) {
    super(floorplan, options);
    this.__eventDispatcher = new EventDispatcher();
    this.__room = room;
    this.__fontSize = Configuration.getNumericValue(fontSize);
    this.__currentFontSize = Configuration.getNumericValue(currentFontSize);
    this.__baseColor =
      this.__room && this.__room.baseColor ? this.__room.baseColor : "#000000";
    let lineHeight =
      this.__fontSize < 36 ? this.__fontSize * 1 : this.__fontSize * 0.8;
    let fontSizeL = this.__fontSize;
    if (this.__room && this.__room.baseColor) {
    } else {
      fontSizeL = this.__currentFontSize;
      lineHeight =
        this.__currentFontSize < 36
          ? this.__currentFontSize * 1
          : this.__currentFontSize * 0.8;
    }

    this.__roomNameField = new Text("Room Area ", {
      fontFamily: "Arial",
      fontSize: fontSizeL,
      fill: this.__baseColor,
      align: "center",
      lineHeight: lineHeight,
    });
    this.__roomAreaField = new Text("Room Area ", {
      fontFamily: "Arial",
      fontSize: fontSizeL,
      fill: this.__baseColor,
      align: "center",
      lineHeight: lineHeight,
    });

    this.__roomAreaField.alpha = 1.0;
    this.__roomAreaField.resolution = 2;
    this.__roomNameField.alpha = 1.0;
    this.__roomNameField.resolution = 2;

    this.__roomNameField.interactive = true;
    this.__roomAreaField.interactive = true;

    this.__roomNameField.buttonMode = true;
    this.__roomAreaField.buttonMode = true;

    this.__roomDimensions = new Graphics();

    this.__roomDimensions.interactive = true;
    this.__roomDimensions.buttonMode = true;

    this.__outerLine = new Graphics();

    this.__outerLine.zIndex = -1;

    if (!this.__room.isDelete) {
      //  this.__roomDimensions.addChild(this.__roomNameField);
      this.__roomDimensions.addChild(this.__roomAreaField);
      this.__roomDimensions.addChild(this.__outerLine);

      this.addChild(this.__roomDimensions);
    }

    this.__drawUpdatedLabel();
  }

  drawOutlineBox() {
    this.__outerLine.clear();
    this.__outerLine.beginFill(selectionColor, 0.0);
    this.__outerLine.lineStyle(2, selectionColor);
    this.__outerLine.drawRect(
      -this.__roomDimensions.width / 2 - 5,
      -this.__roomDimensions.height / 2 - 5,
      this.__roomDimensions.width + 10,
      this.__roomDimensions.height + 10,
    );
    this.__outerLine.endFill();
  }

  __drawUpdatedLabel() {
    let roomCenter = this.__room.areaCenter;
    let roomFactor = this.__room.factor || 1;
    let area = (Math.round(this.__room.area * 100) / 100) * roomFactor;
    // let measure = Dimensioning.cmToMeasure(parseInt(area), 2);
    // let measure = Math.round(Dimensioning.cmToMeasure(area.toFixed(1), 2));
    let measure = Dimensioning.cmToMeasure(area.toFixed(1), 2);
    this.__roomDimensions.position.x = Dimensioning.cmToPixel(roomCenter.x);
    this.__roomDimensions.position.y = Dimensioning.cmToPixel(roomCenter.y);

    let offset = 8;
    // this.__roomNameField.position.x = this.__roomAreaField.position.x = this.__roomDimensions.position.x;
    // this.__roomNameField.position.y = this.__roomNameField.position.y - offset;
    // this.__roomAreaField.position.y = this.__roomAreaField.position.y + offset;

    this.__roomAreaField.text = this.__room.name + "\n\n" + measure + " sf";
    this.__roomNameField.text = this.__room.name;
    // this.__roomNameField.fill = 0x000000;
    this.__roomNameField.anchor.set(0.5, 0.5);
    this.__roomAreaField.anchor.set(0.5, 0.5);

    this.drawOutlineBox();
    this.__outerLine.alpha = 0.0;

    if (this.__room.isDelete) {
      this.__roomDimensions.alpha = 0.0;
    }
  }

  __mouseClickDelete() {
    this.__room.isDelete = true;
    this.remove();
  }

  __updateDimensionTextColor(color, alpha) {
    this.__roomAreaField.style.fill = color;
    this.__roomNameField.style.fill = color;
    this.__roomAreaField.alpha = alpha;
    this.__roomNameField.alpha = alpha;
  }

  __drawSelectedState() {
    this.__updateDimensionTextColor(selectionColor, 1.0);
    this.__outerLine.alpha = 1.0;
  }
  __drawHoveredOnState() {
    this.__updateDimensionTextColor(selectionColor, 1.0);
    this.__outerLine.alpha = 0.5;
  }
  __drawHoveredOffState() {
    this.__updateDimensionTextColor(this.__baseColor, 1.0);
    this.__outerLine.alpha = 0.0;
  }

  get room() {
    return this.__room;
  }
}

export class RoomView extends BaseFloorplanViewElement {
  constructor(floorplan, options, room) {
    super(floorplan, options);

    this.__eventDispatcher = new EventDispatcher();
    this.__room = room;
    this.__updatedRoomEvent = this.__drawUpdatedRoom.bind(this);

    this.__baseColor =
      this.__room && this.__room.baseColor ? this.__room.baseColor : "#000000";

    this.__roomDimensions = new RoomDimensions(floorplan, options, room);

    this.interactive = !room.isLocked;
    this.buttonMode = room.isLocked;

    this.__pixiIndex = 0;

    if (room.isLocked) {
      this.__deactivate();
    }

    if (!room.isDelete) {
      this.addChild(this.__roomDimensions);
    }

    this.__room.addEventListener(
      EVENT_ROOM_ATTRIBUTES_CHANGED,
      this.__updatedRoomEvent,
    );
    this.__room.addEventListener(EVENT_CHANGED, this.__updatedRoomEvent);
    Configuration.getInstance().addEventListener(
      EVENT_CHANGED,
      this.__updatedRoomEvent,
    );
    this.__drawUpdatedLabel();
    this.__mouseOut();
  }

  __drawUpdatedLabel() {
    this.__roomDimensions.__drawUpdatedLabel();
  }

  __drawUpdatedRoom() {
    // console.log(this.__room.isDelete);
    this.__drawUpdatedLabel();
    this.__drawPolygon();
    this.__drawHoveredOffState();
  }

  __drawPolygon(color, alpha = 1.0) {
    let points = [];
    this.clear();
    this.beginFill(color, 0.2);

    // this.__room.interiorCorners.forEach((corner) => {
    //     points.push(new Vector2(corner.x, corner.y));
    // });
    this.__room.corners.forEach((corner) => {
      points.push(new Vector2(corner.x, corner.y));
    });

    for (let i = 0; i < points.length; i++) {
      let x = Dimensioning.cmToPixel(points[i].x);
      let y = Dimensioning.cmToPixel(points[i].y);
      if (i === 0) {
        this.moveTo(x, y);
      } else {
        this.lineTo(x, y);
      }
    }
    this.endFill();
  }

  __drawSelectedState() {
    this.__drawPolygon(0x00ba8c, 1.0);
  }
  __drawHoveredOnState() {
    this.__drawPolygon(0x008cba, 1.0);
  }
  __drawHoveredOffState() {
    this.__drawPolygon(0xffffff, 1.0);
  }

  remove() {
    this.__room.removeEventListener(
      EVENT_ROOM_ATTRIBUTES_CHANGED,
      this.__updatedRoomEvent,
    );
    this.__room.removeEventListener(EVENT_CHANGED, this.__updatedRoomEvent);
    Configuration.getInstance().removeEventListener(
      EVENT_CHANGED,
      this.__updatedRoomEvent,
    );
    super.remove();
  }

  get roomDimensions() {
    return this.__roomDimensions;
  }

  // set roomDimensions(value) {
  //     if (value) {
  //         this.__roomDimensions.alpha = 1.0;
  //         return;
  //     }
  //     this.__roomDimensions.alpha = 1.0;
  // }

  get room() {
    return this.__room;
  }

  get pixiIndex() {
    return this.__pixiIndex;
  }

  set pixiIndex(index) {
    this.__pixiIndex = index;
  }
}
